import { DefaultTheme } from "styled-components";

export const autoWidth = (size: string | undefined) => {
  switch (size) {
    case "xs":
      return "24px";
    case "xxs":
      return "24px";
    case "small":
      return "32px";
    case "medium":
      return "40px";
    case "large":
      return "38px";
    default:
      return "32px";
  }
};

export const buttonColors = (theme: DefaultTheme, type: string | undefined) => {
  switch (type) {
    case "primary":
      return theme.primaryBackground;
    case "secondary":
      return theme.primaryAction;
    case "neutral":
      return theme.neutralBackground;
    case "neutral-color":
      return theme.neutralBackgroundMedium;
    case "disabled":
      return theme.neutralBackground;
    case "danger":
      return theme.alertBackground;
    case "dangerInvert":
      return theme.alertBackgroundStrong;
    default:
      return theme.primaryBackground;
  }
};

export const buttonLine = (theme: DefaultTheme, type: string | undefined) => {
  switch (type) {
    case "primary":
      return theme.primaryBorder;
    case "secondary":
      return theme.secondaryBorder;
    case "neutral":
      return theme.neutralBorderMedium;
    case "neutral-color":
      return theme.neutralBorder;
    case "disabled":
      return theme.neutralBorder;
    case "danger":
      return theme.alertBorder;
    case "dangerInvert":
      return theme.neutralBorder;
    default:
      return theme.primaryBorder;
  }
};

export const buttonHoverColors = (
  theme: DefaultTheme,
  type: string | undefined
) => {
  switch (type) {
    case "primary":
      return theme.primaryBackgroundMedium;
    case "secondary":
      return theme.primaryActionHover;
    case "neutral":
      return theme.neutralBackgroundHover;
    case "neutral-color":
      return theme.neutralBackgroundHover;
    case "disabled":
      return theme.neutralBackground;
    case "danger":
      return theme.alertBackgroundMedium;
    case "dangerInvert":
      return theme.alertBackgroundStrongHover;
    default:
      return theme.primaryBackground;
  }
};

export const buttonActiveColors = (
  theme: DefaultTheme,
  type: string | undefined
) => {
  switch (type) {
    case "primary":
      return theme.primaryBackgroundMedium;
    case "secondary":
      return theme.primaryActionHover;
    case "neutral":
      return theme.neutralBackgroundHover;
    case "neutral-color":
      return theme.neutralBackgroundHover;
    case "disabled":
      return theme.neutralBackground;
    case "danger":
      return theme.alertBackgroundMedium;
    case "dangerInvert":
      return theme.alertBackgroundLight;
    default:
      return theme.primaryBackground;
  }
};

export const textColor = (theme: DefaultTheme, type: string | undefined) => {
  switch (type) {
    case "primary":
      return theme.primaryText;
    case "secondary":
      return theme.primaryTextStrong;
    case "neutral":
      return theme.neutralText;
    case "neutral-color":
      return theme.neutralText;
    case "disabled":
      return theme.neutralTextDisabled;
    case "danger":
      return theme.alertText;
    case "dangerInvert":
      return theme.primaryTextStrong;
    default:
      return theme.primaryAction;
  }
};

export const searchBarWidth = (size: string | undefined) => {
  switch (size) {
    case "xs":
      return "200px";
    case "small":
      return "240px";
    case "medium":
      return "280px";
    case "large":
      return "320px";
    default:
      return "100%";
  }
};